import React from "react";
// import userImg from "../../images/user.png";
import "../../Styles/profile/ProfileStyle.css";

const ProfileAc = () => {
  return (
    <div className="profile-wrapper">
      <div className="profile-card">
        {/* Header */}
                <div className="profile-body">
          {/* Tabs */}
          <ul className="profile-tabs">
            <li className="active">Overview</li>
            <li>Edit</li>
            <li>Change Password</li>
          </ul>

          {/* Content */}
          <div className="profile-content">
            {/* LEFT */}
            <div className="profile-box">
              <div className="profile-left">
                <img alt="User" className="profile-avatar" />

                <h5>Demo AccountantDA</h5>
                <p>Accountant</p>

                <table className="profile-table">
                  <thead>
                    <tr>
                      <th colSpan="2">Contact Information</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Email</td>
                      <td>accountant30@mailinator.com</td>
                    </tr>

                    <tr>
                      <td>Email Status</td>
                      <td>
                        <span className="status-badge warning">
                          Not Verified
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Phone</td>
                      <td>9988776655</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* RIGHT */}
            <div className="profile-box">
              <table className="profile-table">
                <thead>
                  <tr>
                    <th colSpan="2">General Information</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Address</td>
                    <td>Mumbai</td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>Mumbai</td>
                  </tr>
                  <tr>
                    <td>Nationality</td>
                    <td>🇮🇳 India</td>
                  </tr>
                  <tr>
                    <td>Joining Date</td>
                    <td>Mon Aug 12 2019</td>
                  </tr>
                  <tr>
                    <td>Date of Birth</td>
                    <td>Thu May 6 2004</td>
                  </tr>
                  <tr>
                    <td>Gender</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>Internal No.</td>
                    <td>
                      <span className="status-badge info">6767jhjh</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileAc;
